import React from 'react';

import { AppContext } from '_AppContainer';

// TODO: add type
/**
 * Custom hook to access AppContext with fallback.
 * Returns the context value if available, otherwise returns an empty object.
 *
 * @returns {any} The current app context value or fallback.
 */
export const useAppContext = () => {
	const context = React.useContext<any>(AppContext);
	if (context === undefined || context === null) {
		return {};
	}

	return context;
};
